<template>
    <div></div>
</template>
<script>
import user from '@/user'
export default {
	created: function () {
		user.logout()
	}
}
</script>



// WEBPACK FOOTER //
// src/pages/user/account/logout.vue